export interface ItemConfig {
  id: string;
  name: string;
  imageUrl: string;
  description?: string;
  dialog?:string;
}

// Master list of all items in the game
export const itemsConfig: ItemConfig[] = [
  {
    id: 'teddy_bear',
    name: 'Boneka Beruang',
    imageUrl: 'assets/items/item_boneka.png',
    description: 'Boneka ditemukan',
    dialog : "Yan mendapatkan boneka beruang!"
  },
  {
    id: 'coin_gold',
    name: 'Uang',
    imageUrl: 'assets/items/item_uang.png',
    description: 'A shiny gold coin.',
  },
  {
    id: 'cap_tikus',
    name: 'Cap Tikus',
    imageUrl: 'assets/items/item_drink2.png',
    description: 'A shiny gold coin.',
  },
  {
    id: 'bible',
    name: 'Alkitab',
    imageUrl: 'assets/items/item_bible.png',
    description: 'A shiny gold coin.',
  },
  {
    id: 'panada',
    name: 'Panada',
    imageUrl: 'assets/items/item_panada.png',
    description: 'A shiny gold coin.',
  },
  {
    id: 'fish',
    name: 'Ikan',
    imageUrl: 'assets/items/item_ikan.png',
    description: 'A shiny gold coin.',
  },
  {
    id: 'liontin',
    name: 'Liontin',
    imageUrl: 'assets/items/item_liontin.png',
    description: 'A shiny gold coin.',
  },
  {
    id: 'sendal',
    name: 'Sendal',
    imageUrl: 'assets/items/item_sendal.png',
    description: 'A shiny gold coin.',
  },
];

// Helper function to get item config by ID
export function getItemConfig(itemId: string): ItemConfig | undefined {
  return itemsConfig.find(item => item.id === itemId);
}

// Helper function to validate if an item ID exists
export function isValidItemId(itemId: string): boolean {
  return itemsConfig.some(item => item.id === itemId);
}
